/**
 * FrAPISearchModel except the term -- just the options.
 * Deemed easier for user to provide options -- rather than build the other way via composition
 * ( and have more nested objects
 */


var FrAPISearchModel = require('./frApiSearchModel');


module.exports = FrAPISearchModel.extend( {

    defaults: _.omit( FrAPISearchModel.prototype.defaults, 'term' ),

    // Currently not checking anything, everything fails silently
    validate: function( ) { }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/api/frApiGlobalOptions.js
 ** module id = 681
 ** module chunks = 0
 **/